import './login-form.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import InputField from  '../../shared/form-elements/input';

const Form = ({
	handleSubmit,
	pristine,
	submitting,
	login,
	error
}) => {
	return (
		<div className="login-layout">
			<div className="form-container">
				<div className="form-container__head">
					<span className="logo">
						<span className="logo__text">Admin panel</span>
					</span>
				</div>
				{process.env.CPA_ENV === 'rocket' && (
					<div style={{ color: 'red' }}>
						Вместо rp.ckp1.com пользуемся <a href='https://ckp2.com'>ckp2.com</a>!
					</div>
				)}
				<div className="form-container__body">
					<form className="login__form ui-form" onSubmit={handleSubmit(formData => login(formData))}>
						<div className="login__form-element ui-form__element">
							<Field name="email" placeholder="Email" component={InputField} />
						</div>

						<div className="login__form-element ui-form__element">
							<Field name="password" placeholder="Password" type="password" component={InputField} />
						</div>

						{error && <div className="login__form-element ui-form__element error">
							{error}
						</div>}

						<div className="login__form-element ui-form__element">
							<button type="submit" className="ui-btn ui-btn-primary" disabled={pristine || submitting}>Login</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

Form.propTypes = {
	handleSubmit: PropTypes.func,
	pristine: PropTypes.bool,
	submitting: PropTypes.bool,
	login: PropTypes.func
};

export default reduxForm({
	form: 'loginForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/root/components/login-form.js